import { ChangeEvent, ReactElement, useEffect, useState } from "react";
import { IDictionary } from "../../../types";
import { IDashboard } from "../types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow, TextField,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { cloneObject, sortText } from "../../../system/utils";
import StyledTableRow from "../../../components/styledTableRow";
import TableContainer from "../../../components/tableContainer";
import ColorPicker from "../../../components/colorPicker";

interface IProps {
  setDashboard: (dashboard: IDashboard) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  dashboard: IDashboard;
}

const getColorObject = (palette: IDictionary<string>): IDictionary<string> => {
  const result: IDictionary<string> =  {};

  Object.keys(palette).forEach(key => {
    result[key] = palette[key];
  });

  return result;
};


const PaletteDialog = ({ open, dashboard, setDashboard, setOpen }: IProps): ReactElement => {
  const [ filter, setFilter ] = useState<string>("");
  const [ palette, setPalette ] = useState<IDictionary<string>>({});
  const [ colors, setColors ] = useState<IDictionary<string>>({});

  useEffect(() => {
    if (open) {
      setPalette(cloneObject(dashboard.layout.palette));
      setColors(getColorObject(dashboard.layout.palette));
      setFilter("");
    }
  }, [open]);

  const onAccept = () => {
    setOpen(false);
    const newValue = cloneObject(dashboard);
    newValue.layout.palette = palette;
    setDashboard(newValue);
  };

  const onCancel = () => {
    setOpen(false);
    setPalette({});
  };

  const onUpdateColor = (key: string, color: any) => {
    setColors({ ...colors, [key]: color });
    setPalette({ ...palette, [key]: `#${color.hex}` });
  };

  // const removeColor = (key: string) => {
  //   const newPalette = { ...palette };
  //   delete newPalette[key];
  //   setPalette(newPalette);
  //
  //   const newColors = { ...colors };
  //   delete newColors[key];
  //   setColors(newColors);
  // };

  return (
    <Dialog onClose={onCancel} aria-labelledby="customized-dialog-title" open={open} maxWidth="md">
      <DialogTitle id="customized-dialog-title">
        Palette
      </DialogTitle>
      <DialogContent dividers={true}>

        <TextField
          variant="standard"
          sx={{ margin: "1em", width: 300 }}
          placeholder={"Filter"}
          label={"Filter"}
          value={filter}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setFilter(e.target.value)}/>

        <TableContainer sx={{ height: 431 }}>
          <Table stickyHeader={true} size={"small"}>
            <TableHead>
              <TableRow>
                <TableCell className="table-header" style={{ minWidth: 200 }}>Value</TableCell>
                <TableCell className="table-header">Color</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(palette).filter(x => filter === "" || x.indexOf(filter) >= 0 ).sort(sortText).map((key, index) => {
                return (
                  <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`palette-row-${index}`}>
                    <TableCell>{key}</TableCell>
                    <TableCell>
                      <FormControl className="w-100">
                        {/*<input type="color" value={palette[key]} onChange={(event: ChangeEvent<HTMLInputElement>) => onUpdateColor(key, event.target.value as string)}/>*/}
                        <ColorPicker color={colors[key]} onChange={(color) => onUpdateColor(key,  color)} disableAlpha={true}/>
                      </FormControl>
                    </TableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onAccept} variant="contained" color="primary"  startIcon={<CheckIcon />}>
          Accept
        </Button>
        <Button onClick={onCancel} variant="contained" color="secondary" startIcon={<CloseIcon />}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaletteDialog;
